<template>
  <div id="app">
    <div class="my-nav">
      <ul class="nav justify-content-center fixed-top">
        <li class="nav-item">
          <a class="nav-link" href="#landing">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#skills">Skills</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#services" >Services</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#projects">Projects</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#contact">Contact</a> 
        </li>
      </ul>
    </div>
    <router-view />
    <footer class="sticky-bottom">
      <div class="pt-2 pb-2 d-flex align-items-center justify-content-center">
        &copy; MungaiGikure  {{year}}
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data(){
    return{
      year: null
    }
  },
  created(){
    this.year = new Date().getFullYear();
    document.title ="Mungai Gikure";
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Antic+Slab&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100&family=Rock+Salt&display=swap');


html{
  transition-delay: 2s;
  scroll-behavior: smooth; 
}
body{
  margin: 0;
  padding: 0;
  /* background: rgb(131, 225, 253); */
  height: 100% !important;
  width: 100% !important;
}
#app{
  /* font-family: 'Libre Baskerville', serif; */
  /* font-family: 'Antic Slab', serif; */
  font-family: 'Poppins', serif;
  font-size: 20px;
  color: black;
  font-weight: bold;
  margin: 0;
  padding: 0;
  /* background: rgb(131, 225, 253); */
}


#nav a {
  font-weight: bold;
  color: #2c3e50;
}

.my-nav a.router-link-exact-active {
  /* color: #42b983; */
  color:whitesmoke;
}
.nav{
  background: rgba(55, 71, 190, 0.5); 
  /* margin-top: 20px;   */
}
.my-nav{
  background: rgba(55, 71, 190, 0.5); 
  /* margin-top: 20px; */
}
.my-nav a{
  color:white;
}
.my-nav a:hover{
  /* color:goldenrod; */
  color:white;
  font-size: 18px;
}

footer{
  background: rgba(25, 47, 211, 0.644);
  color: white;
}
h1{
  font-size: 30px;
}

</style>
